import SlimSelect from "slim-select";

document.addEventListener("DOMContentLoaded",
  () => {

    /* Валидация происходит в 2 этапа: js проверка валидностии данных и бэкенд проверка корректности данных после отправки (см. Model.ResponseMessage)

    Валидация формы (интерфейс).
    validateForm - проверка всей формы при отправке.
    validateField - проверка полей формы.

    Атрибуты полей формы (input):
        1. data-field - атрибут, указывающий конкретное поле и в какой форме оно находится: <название-формы>-<название поля>. Например: data-field="login-email".
        2. data-validate - атрибут, указывающий какие валидаторы используются для поля. Например, required и проверка на корректность email должны формироваться так: data-validate="required,email".

    Атрибуты уведомления об ошибке (.notify):
        1. id - уникальный идентификатор ошибки: <название-формы>-<название поля>-error-message. Например: id="login-email-error-message".
        2. data-required - текст, который выводится в случае ошибки по валидатору required (рекомендуется локализация, а не просто текст). Например: data-required="@ViewData[L10nKeys.LoginEmailRequiredError]".
        3. data-email - текст, который выводится в случае ошибки по валидатору email (рекомендуется локализация, а не просто текст). Например: data-email="@ViewData[L10nKeys.LoginEmailError]".
    */

    const validateFunctions = {
      validateForm: function (form) {
        let inputs = form.querySelectorAll("input[data-validate]");
        let isValid = true;
        inputs.forEach(function (elem) {
          if (!validateFunctions.validateField(elem)) {
            isValid = false;
          }
        });

        return isValid;
      },
      validateField: function (el) {
        const validateAttribute = el.getAttribute("data-validate");
        const validators = validateAttribute.split(",");
        const field = el.getAttribute("data-field");
        let isValid = true;

        let errorMessageContainer = form.querySelector("#" + field + "-error-message");

        validators.forEach(function (validator) {
          if (!validateFunctions[validator].validate(el.value.trim(), errorMessageContainer)) {
            isValid = false;
          }
        });

        if (isValid) {
          if (el.getAttribute("data-invalid")) {
            el.removeAttribute("data-invalid");
          }
          errorMessageContainer.classList.remove('show');
          errorMessageContainer.innerHTML = "";
        } else {
          el.setAttribute("data-invalid", true);
          if (errorMessageContainer.textContent.trim() != "") {
            errorMessageContainer.classList.add('show');
          }
        }

        return isValid;
      },
      email: {
        validate: function (value, errorMessageContainer) {
          const isValid = /^[\w-\.]+@([\w-]+\.)+[\w-]+$/.test(value);

          if (!isValid) {
            const content = errorMessageContainer.getAttribute("data-email");
            errorMessageContainer.innerHTML = content;
          }
          return isValid;
        },
      },
      required: {
        validate: function (value, errorMessageContainer) {
          const isValid = value !== null && value.length !== 0;
          if (!isValid) {
            const content = errorMessageContainer.getAttribute("data-required");
            errorMessageContainer.innerHTML = content;
          }

          return isValid;
        },
      },
      password: {
        validate: function (newPassword, errorMessageContainer) {
          const isValid = passwordCheck(newPassword);

          if (!isValid && newPassword.length > 0)
          {
            const content = errorMessageContainer.getAttribute("data-weak");
            errorMessageContainer.innerHTML = content;
          }

          return isValid;
        },
      },
      telegram: {
        validate: function (value, errorMessageContainer) {
          if (!value)
            return true;
          const isRegexMatch = /^[0-9a-zA-Z_]+$/.test(value);
          const isNormalLength = value.length >= 5;
          let content;
          if (!isRegexMatch) {
            content = errorMessageContainer.getAttribute("data-telegram");
            errorMessageContainer.innerHTML = content;
            return false;
          }
          if (!isNormalLength) {
            content = errorMessageContainer.getAttribute("data-telegram-short");
            errorMessageContainer.innerHTML = content;
            return false;
          }
          return true;
        }
      },
      company: {
        validate: function (value, errorMessageContainer) {
          if (!value)
            return true;
          const isNormalLength = value.length < 257;
          if (!isNormalLength)
          {
            const content = errorMessageContainer.getAttribute("data-company");
            errorMessageContainer.innerHTML = content;
            return false;
          }
          return true;
        }
      }
    }

    // Находим форму на странице и её поля, которые требуют валидации.
    const form = document.querySelector('form:not([id="lang-form"])');
    let inputs = form.querySelectorAll("input[data-validate]");

    // Добавляем обработку событий на форму и на поля.
    form.addEventListener("submit", function (e) {
      if (!validateFunctions.validateForm(this)) {
        e.preventDefault();
      };
    });

    const inputHandler = function () {
      const el = document.getElementById("notify");
      if (document.contains(el)) {
        el.remove();
      }

      this.classList.remove("invalid");
      validateFunctions.validateField(this);
    }
    const blurHandler = function () {
      validateFunctions.validateField(this);
    }
    inputs.forEach(function (elem) {
      elem.addEventListener("input", inputHandler);
    });

    // Получаем изображения внешних провайдеров.
    const provideImages = document.getElementsByClassName("provider__image");
    Array.prototype.forEach.call(provideImages,
      function (el) {
        let imgSrc = "../ui/images/unknown-logo.svg";
        const name = el.id.split(":")[0];
        if (name === "facebook") {
          imgSrc = "../ui/images/facebook-logo.svg";
        }
        if (name === "google") {
          imgSrc = "../ui/images/google-logo.svg";
        }
        if (name === "yandex") {
            imgSrc = "../ui/images/yandex-logo.svg";
        }
        if (name === "vk") {
            imgSrc = "../ui/images/vk-logo.svg";
        }
        el.src = imgSrc;
      });


    // Селект переключения языка.
    let langSelect = document.getElementById("select-lang");
    let loadedLang = document.getElementById("loadedCulture").value;
    let selectTitle = document.getElementById("changeLangMsg").value;
    let languageTitle = langSelect ? langSelect.getAttribute("placeholder-text") : null;
    function getSelected(lang) {
      let selectedLang = "ru-RU";
      if (loadedLang) selectedLang = loadedLang;
      if (selectedLang === lang) {
        return "selected";
      } else {
        return "";
      }
    }

    if (langSelect) {
      const selectLang = new SlimSelect({
        select: "#select-lang",
        showSearch: false,
        valuesUseText: false,
        data: [
          {
            text: languageTitle, //'System lang'
            class: "select__option select__option--title",
            disabled: true
          },
          {
            innerHTML:
              '<img class="select__image" width="32" height="16" src="../ui/images/select-lang/rus.png"><span class="select__text">Русский язык</span>',
            text: "Русский язык",
            value: "ru-RU",
            class: "select__option select__option--with-icon",
            selected: getSelected("ru-RU")
          },
          {
            innerHTML:
              '<img class="select__image" width="32" height="16" src="../ui/images/select-lang/eng.jpg"><span class="select__text">English</span>',
            text: "English",
            value: "en-US",
            class: "select__option select__option--with-icon",
            selected: getSelected("en-US")
          }
        ]
      });

      if (selectTitle) selectLang.slim.container.setAttribute("title", selectTitle);
      langSelect.addEventListener("change",
        function (event) {
          event.preventDefault();
          this.form.submit();
        },
        false);
    }

    // Show pass in pass field
    const showPassButton = document.getElementById("show-pass");
    const passField = document.querySelector('input[type="password"]');

    if (showPassButton)
      showPassButton.addEventListener("click",
        event => {
          event.preventDefault();
          changeButtonState();
          changeFieldState();
        });

    function changeButtonState() {
      showPassButton.classList.toggle("button--show-on");
      showPassButton.classList.toggle("button--show-off");
    }

    function changeFieldState() {
      if (passField.type === "password") {
        passField.type = "text";
      } else {
        passField.type = "password";
      }
    }

    // Clean login field
    const cleanButton = document.getElementById("clean-field");

    if (cleanButton) {
      const cleaningField = cleanButton.parentNode;

      if (cleaningField) {
        const cleaningInput = cleaningField.querySelector("input");

        if (cleaningInput) {
          cleanButton.addEventListener("click",
            event => {
              event.preventDefault();
              cleaningInput.value = "";
            });
        }
      }
    }


    // Get random number
    function randomInt(max) {
      return Math.floor(Math.random() * max);
    }

    // Password complexity check
    const passCheckingWrapper = document.querySelector(".field--with-tooltip");

    if (passCheckingWrapper) {
      const passCheckingField = passCheckingWrapper.querySelector(".field__input");

      if (passCheckingField) {
        passCheckingField.addEventListener("keyup",
          () => {
            passwordCheck(passCheckingField.value);
          });
        passCheckingField.addEventListener("focus",
          () => {
            passwordCheck(passCheckingField.value);
          });
      }
    }

    function progressBarSet(state) {
      const passProgressBar = passCheckingWrapper.querySelector(".tooltip__progress");

      if (passProgressBar) {
        passProgressBar.className = "";
        passProgressBar.classList.add("tooltip__progress");
        if (state) {
          passProgressBar.classList.add(`tooltip__progress--${state}`);
        }
      }
    }

    function tooltipSet(state) {
      const tooltipTitle = passCheckingWrapper.querySelector(".tooltip__title");
      const tooltipDesc = passCheckingWrapper.querySelector(".tooltip__text");

      const tooltipTitleLocalized = tooltipTitle.getAttribute(`data-${state}`);
      const tooltipDescLocalized = tooltipDesc.getAttribute(`data-${state}`);

      if (tooltipTitle && tooltipDesc) {
        tooltipTitle.innerHTML = tooltipTitleLocalized;
        tooltipDesc.innerHTML = tooltipDescLocalized;
      }
    }

    function passwordComplexityCheck(password) {
      let passwordComplexity = 0;
      const passwordComplexityChars = [
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        "abcdefghijklmnopqrstuvwxyz",
        "0123456789",
        "~!@#$%^&*-+=/|?;:,[]\\_{}`()<>'\"."
      ];

      for (let charsString of passwordComplexityChars) {
        for (let char of password) {
          if (charsString.indexOf(char) !== -1) {
            passwordComplexity++;
            break;
          }
        }
      }

      return passwordComplexity;
    }

    function passwordCorrectCheck(password) {
      const correctChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*-+=/|?;:,[]\\_{}`()<>'\".";
      for (let char of password) {
        if (correctChars.indexOf(char) === -1) {
          return false;
        }
      }
      return true;
    }

    function passwordCheck(newPassword) {
      const minPasswordLength = 6;
      let isValid = true;

      if (!newPassword) {
        progressBarSet();
        isValid = false;
        return isValid;
      }

      if (newPassword.length < minPasswordLength) {
        progressBarSet("min");
        tooltipSet("short");
        isValid = false;
      } else {
        progressBarSet("middle");

        if (!passwordCorrectCheck(newPassword)) {
          tooltipSet("invalid");
          isValid = false;
        } else {
          let passwordComplexity = 0;
          passwordComplexity = passwordComplexityCheck(newPassword);
          if (passwordComplexity < 4) {
            tooltipSet("weak");
            isValid = false;
          } else {
            progressBarSet("max");
            tooltipSet("valid");
          }
        }
      }

      return isValid;
    }
  });
